// antd-vue按需引入集成
import {
  Transfer, Table, ConfigProvider
} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
const antdVue = {
  install: function (Vue) {
    Vue.use(Table)
    Vue.use(Transfer)
    Vue.use(ConfigProvider)
  }
}
export default antdVue
